import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  //Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as ticketAction from "../../store/dGlja2V0U3/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import api from "helpers/Api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

//ticketAction
const TicketSummary = (props) => {
  const { searchBtnStyle, dispatch } = props

  const title = "Ticket Summary"
  //ticketSummaryData ,setTicketSummaryData
  const [ticketSummaryData, setTicketSummaryData] = useState({
    ticketFromDate: "",
    ticketToDate: "",
    directMember: "",
    ccMember: "",
  })

  const [label, setLabel] = useState([])
  const [ticketStatus, setTicketStatus] = useState([])
  //Fetching API
  useEffect(() => {
    dispatch(
      ticketAction.loadTicketSummary({
        page: 1,
        limit: 50,
      })
    )
    dispatch(ticketAction.loadRecordsMetaData())
  }, [])
  //remote pagination
  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  //date format
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const update = useSelector((specificstate) => specificstate.ticketSummary)

  //ticket_data
  const { ticket_data = [], recordsMetaData = {} } = update

  const handleChange = (e) => {
    setTicketSummaryData({
      ...ticketSummaryData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)
  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)

  // const [searchValue, setSearchValue] = useState({})
  const handleFilter = (e) => {
    e.preventDefault()

    var searchFromDate =
      ticketSummaryData && ticketSummaryData.ticketFromDate
        ? moment(ticketSummaryData.ticketFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketSummaryData && ticketSummaryData.ticketToDate
        ? moment(ticketSummaryData.ticketToDate).format("YYYY-MM-DD")
        : ""
    var searchDirectMember =
      ticketSummaryData && ticketSummaryData.directMember
        ? ticketSummaryData.directMember
        : ""
    var searchCCMember =
      ticketSummaryData && ticketSummaryData.ccMember
        ? ticketSummaryData.ccMember
        : ""
    var searchTicketStatus = !isEmpty(ticketStatus) ? ticketStatus.value : ""
    var searchLabel = !isEmpty(label) ? label.value : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50

    if (searchFromDate) {
      searchvalue.ticketFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.ticketToDate = searchToDate
    }
    if (searchDirectMember) {
      searchvalue.reportingTo = searchDirectMember
    }
    if (searchCCMember) {
      searchvalue.reportingBc = searchCCMember
    }
    if (searchTicketStatus) {
      searchvalue.queryId = searchTicketStatus
    }
    if (searchLabel) {
      searchvalue.labelId = searchLabel
    }
    //setSearchValue(searchvalue)
    dispatch(ticketAction.loadTicketSummary(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setSearchInput("")
    setTicketStatus([])
    setLabel([])
    setTicketSummaryData({
      ...ticketSummaryData,
      ticketFromDate: "",
      ticketToDate: "",
      directMember: "",
      ccMember: "",
    })
    dispatch(
      ticketAction.loadTicketSummary({
        page: 1,
        limit: 50,
      })
    )
  }

  const ticketTable = !isEmpty(ticket_data)
    ? ticket_data.data.map((data, index) => {
        const sender = !isEmpty(data.senderName)
          ? data.senderName.map((m) => m).join(",")
          : "--"
        const directMember = !isEmpty(data.directMemberName)
          ? data.directMemberName.map((m) => m).join(",")
          : "--"
        const ccMemberName = !isEmpty(data.ccMemberName)
          ? data.ccMemberName.map((m) => m).join(",")
          : "--"
        const colorCode =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.ticketProcessStatusOptions &&
          recordsMetaData.ticketProcessStatusOptions.length > 0 &&
          recordsMetaData.ticketProcessStatusOptions.find(
            (_) => _.value === data.queryStatus
          ) &&
          recordsMetaData.ticketProcessStatusOptions.find(
            (_) => _.value === data.queryStatus
          ).colorCode
        return {
          _id: index,
          sNo: index + 1,
          ticketNo: data.refNo ? data.refNo : "--",
          sender: sender,
          senderId: data.senderId,
          directMemberId: data.directMember,
          subject: data.subject ? data.subject : "--",
          label: data.labelName ? data.labelName : "--",
          directMember: directMember,
          ccMember: ccMemberName,
          ticketDate: data.ticketDate
            ? moment(data.ticketDate).format(dateFormat)
            : "--",
          ticketStatus: data.queryStatus ? data.queryStatus : "--",
          ticketStatusName: data.queryStatusName ? data.queryStatusName : "--",
          activities: data.activities ? data.activities : "--",
          colorCode: colorCode,
        }
      })
    : []

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "ticketNo",
      text: "Ticket No",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "sender",
      text: "Sender",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "subject",
      text: "Subject",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "label",
      text: "Label",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "directMember",
      text: "Direct Member",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "ccMember",
      text: "CC Member",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "ticketDate",
      text: "Ticket Date",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "ticketStatusName",
      text: "Ticket Status",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
      formatter: (cellContent, row) => {
        return !isEmpty(row.ticketStatusName) && !isEmpty(row.colorCode) ? (
          <div>
            <button
              style={{
                background: row.colorCode,
                border: "none",
                cursor: "pointer",
                color: "white",
                padding: "2px",
                borderRadius: "4px",
              }}
            >
              {row.ticketStatusName}
            </button>
          </div>
        ) : (
          <div>{row.ticketStatusName}</div>
        )
      },
    },
    {
      dataField: "activities",
      text: "Activities",
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
  ]

  const [loading, setLoading] = useState(false)
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      ticketAction.loadTicketSummary({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchFromDate =
      ticketSummaryData && ticketSummaryData.ticketFromDate
        ? moment(ticketSummaryData.ticketFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketSummaryData && ticketSummaryData.ticketToDate
        ? moment(ticketSummaryData.ticketToDate).format("YYYY-MM-DD")
        : ""
    var searchDirectMember =
      ticketSummaryData && ticketSummaryData.directMember
        ? ticketSummaryData.directMember
        : ""
    var searchCCMember =
      ticketSummaryData && ticketSummaryData.ccMember
        ? ticketSummaryData.ccMember
        : ""
    var searchTicketStatus = !isEmpty(ticketStatus) ? ticketStatus.value : ""
    var searchLabel = !isEmpty(label) ? label.value : ""
    var searchvalue = {}

    if (searchFromDate) {
      searchvalue.ticketFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.ticketToDate = searchToDate
    }
    if (searchDirectMember) {
      searchvalue.reportingTo = searchDirectMember
    }
    if (searchCCMember) {
      searchvalue.reportingBc = searchCCMember
    }
    if (searchTicketStatus) {
      searchvalue.queryId = searchTicketStatus
    }
    if (searchLabel) {
      searchvalue.labelId = searchLabel
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get-ticket-summery-export-excel-report`, searchvalue)
      .then((response) => {
        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              const sender = !isEmpty(data.senderName)
                ? data.senderName.map((m) => m).join(",")
                : "--"
              const senderValue = JSON.stringify(sender).replace(/","/g, "\n")
              const directMember = !isEmpty(data.directMemberName)
                ? data.directMemberName.map((m) => m).join(",")
                : "--"
              const directMemberValue = JSON.stringify(directMember).replace(
                /","/g,
                "\n"
              )
              const ccMemberName = !isEmpty(data.ccMemberName)
                ? data.ccMemberName.map((m) => m).join(",")
                : "--"
              const ccMemberNameValue = JSON.stringify(ccMemberName).replace(
                /","/g,
                "\n"
              )
              return {
                _id: index,
                sNo: index + 1,
                ticketNo: data.refNo ? data.refNo : "--",
                sender: senderValue,
                senderId: data.senderId,
                directMemberId: data.directMember,
                subject: data.subject ? data.subject : "--",
                label: data.labelName ? data.labelName : "--",
                directMember: directMemberValue,
                ccMember: ccMemberNameValue,
                ticketDate: data.ticketDate
                  ? moment(data.ticketDate).format(dateFormat)
                  : "--",
                ticketStatus: data.queryStatus ? data.queryStatus : "--",
                ticketStatusName: data.queryStatusName
                  ? data.queryStatusName
                  : "--",
                activities: data.activities ? data.activities : "--",
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo, Ticket No,Sender,Subject,Label,Direct Member,CC Member,Ticket Date,Ticket Status,Activities",
          ]

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                ticketNo,
                sender,
                subject,
                label,
                directMember,
                ccMember,
                ticketDate,
                ticketStatusName,
                activities,
              } = user
              acc.push([
                sNo,
                ticketNo,
                sender,
                subject,
                label,
                directMember,
                ccMember,
                ticketDate,
                ticketStatusName,
                activities,
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "TicketSummary.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
    // }
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          wrapperClasses="table-responsive"
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: ticket_data.length,
    data:
      !isEmpty(ticket_data) && ticket_data.length > 0
        ? ticket_data.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(ticket_data.data) && ticket_data.data.length > 0
        ? ticket_data.data
        : []
    if (
      !isEmpty(ticketSummaryData.ticketFromDate) ||
      !isEmpty(ticketSummaryData.ticketToDate) ||
      !isEmpty(ticketSummaryData.directMember) ||
      !isEmpty(ticketSummaryData.ccMember) ||
      !isEmpty(ticketSummaryData.ticketStatus) ||
      !isEmpty(label)
    ) {
      var searchFromDate =
        ticketSummaryData && ticketSummaryData.ticketFromDate
          ? moment(ticketSummaryData.ticketFromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        ticketSummaryData && ticketSummaryData.ticketToDate
          ? moment(ticketSummaryData.ticketToDate).format("YYYY-MM-DD")
          : ""
      var searchDirectMember =
        ticketSummaryData && ticketSummaryData.directMember
          ? ticketSummaryData.directMember
          : ""
      var searchCCMember =
        ticketSummaryData && ticketSummaryData.ccMember
          ? ticketSummaryData.ccMember
          : ""
      var searchTicketStatus = !isEmpty(ticketStatus) ? ticketStatus.value : ""
      var searchLabel = !isEmpty(label) ? label.value : ""
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50

      if (searchFromDate) {
        searchvalue.ticketFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.ticketToDate = searchToDate
      }
      if (searchDirectMember) {
        searchvalue.reportingTo = searchDirectMember
      }
      if (searchCCMember) {
        searchvalue.reportingBc = searchCCMember
      }
      if (searchTicketStatus) {
        searchvalue.queryId = searchTicketStatus
      }
      if (searchLabel) {
        searchvalue.labelId = searchLabel
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      dispatch(ticketAction.loadTicketSummary(searchvalue))
    } else {
      dispatch(
        ticketAction.loadTicketSummary({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Ticket From Date"}
                        >
                          {"Ticket From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="ticketFromDate"
                        value={ticketSummaryData.ticketFromDate}
                        max={ticketSummaryData.ticketToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Ticket To Date"}
                        >
                          {"Ticket To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="ticketToDate"
                        value={ticketSummaryData.ticketToDate}
                        min={ticketSummaryData.ticketFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Label</Label>
                      <Select
                        type="text"
                        name="label"
                        value={label}
                        onChange={(e) => setLabel(e)}
                        options={
                          recordsMetaData ? recordsMetaData.labelOptions : []
                        }
                        placeholder="Select Label"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Direct Member"}
                        >
                          {"Direct Member"}
                        </Label>
                      </div>
                      <Input
                        type="test"
                        name="directMember"
                        value={ticketSummaryData.directMember}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Direct Member"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"CC Member"}>
                          {"CC Member"}
                        </Label>
                      </div>
                      <Input
                        type="test"
                        name="ccMember"
                        value={ticketSummaryData.ccMember}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter CC Member"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Ticket Status</Label>
                      <Select
                        type="text"
                        name="ticketStatus"
                        value={label}
                        onChange={(e) => setTicketStatus(e)}
                        options={
                          recordsMetaData
                            ? recordsMetaData.ticketProcessStatusOptions
                            : []
                        }
                        placeholder="Select Ticket Status"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <RemotePagination
                  data={ticketTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={
                    !isEmpty(ticket_data) ? ticket_data.totalDataCount : 0
                  }
                  onTableChange={handleTableChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {btnLoading ? (
        <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {loading ? (
        <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
TicketSummary.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,TicketSummary
})
//TicketSummary
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketSummary)
)
